angular.module('NiacsProjectApp.controllers-export-share', [
])
.filter('exportEllipsis',[function(){
    var MAX_LENGTH = 250;
    return function(text) {
        var ellipsisApplied = false;
        if(text && text.length > MAX_LENGTH) {
            text = text.split(/\s/).reduce(function(carry,word) {
                if(ellipsisApplied) {
                    return carry;
                }
                var next = carry+' '+word;
                if(next.length >= MAX_LENGTH) {
                    ellipsisApplied = true;
                    return carry+' ...';   
                }
                return next;
            });
        }
        return text;
    };
}])
.directive('replaceWithImage',[function() {
    var HTML2CANVAS_LOADED = typeof(html2canvas) !== 'undefined';
    return {
        restrict: 'C',
        scope: {
            imageReady: '@',
        },
        transclude: true,
        template: '<div ng-if="haveHtml2Canvas" class="in-progress-cover"><fa-icon icon="spinner" class="fa-3x" classes="fa-spin"></fa-icon></div><div class="original-contents" ng-transclude></div>',
        link: function($scope,$element,$attrs) {
            $scope.haveHtml2Canvas = HTML2CANVAS_LOADED;
            function render(){
                setTimeout(function() {
                    var original = $element.find('div.original-contents'),
                    cover = $element.find('div.in-progress-cover');
                    html2canvas(original,{
                        proxy: '/html2canvas-proxy',
                        logging: false,
                        onrendered: function(canvas) {
                            var img = new Image();
                            img.onload = function() {
                                img.onload = null;
                                original.remove();
                                cover.remove();
                                $element.append(img);
                            };
                            img.src = canvas.toDataURL('image/png');
                        }
                    });
                },2000); // pausing to let the map render before trying to take an image of it.
            }
            if(HTML2CANVAS_LOADED) {
                if(typeof($attrs.imageReady !== 'undefined')) {
                    var stopWatch = $scope.$watch('imageReady',function(ready) {
                        if(ready === 'true') {
                            stopWatch();
                            render();
                        }
                    });
                } else {
                    render();
                }
            }
        }
    };
}])
.filter('topSkipUrlToRange',[function(){
    return function(url,total) {
        if(url) {
            url = url.replace(/%24/g,'$'); // in case the URL is escaped
            var top = /\$top=(\d+)/.exec(url),
                skip = /\$skip=(\d+)/.exec(url);
            if(top && skip && top.length === 2 && skip.length === 2 ) {
                top = parseInt(top[1]);
                skip = parseInt(skip[1]);
                return (skip+1)+' - '+Math.min((skip+top),total)+' of '+total;
            }
        }
    };
}])
.controller('DemoProjectsDialogCtrl',['$scope','$uibModalInstance','$http','$httpParamSerializer','theProject',function($scope,$uibModalInstance,$http,$httpParamSerializer,theProject){
    // forestadaptation.org uses abbreviates and adaptationworkbook uses full names so as opposed to tediously updating
    // a taxonomy simply map one to the other.
    var STATES_HASH = { 'Alabama': 'AL', 'Alaska': 'AK', 'American Samoa': 'AS', 'Arizona': 'AZ',
    'Arkansas': 'AR', 'California': 'CA', 'Colorado': 'CO', 'Connecticut': 'CT', 'Delaware': 'DE',
    'District Of Columbia': 'DC', 'Federated States Of Micronesia': 'FM', 'Florida': 'FL', 'Georgia': 'GA',
    'Guam': 'GU', 'Hawaii': 'HI', 'Idaho': 'ID', 'Illinois': 'IL', 'Indiana': 'IN', 'Iowa': 'IA', 'Kansas': 'KS',
    'Kentucky': 'KY', 'Louisiana': 'LA', 'Maine': 'ME', 'Marshall Islands': 'MH', 'Maryland': 'MD', 'Massachusetts': 'MA',
    'Michigan': 'MI', 'Minnesota': 'MN', 'Mississippi': 'MS', 'Missouri': 'MO', 'Montana': 'MT', 'Nebraska': 'NE',
    'Nevada': 'NV', 'New Hampshire': 'NH', 'New Jersey': 'NJ', 'New Mexico': 'NM', 'New York': 'NY', 'North Carolina': 'NC',
    'North Dakota': 'ND', 'Northern Mariana Islands': 'MP', 'Ohio': 'OH', 'Oklahoma': 'OK', 'Oregon': 'OR', 'Palau': 'PW',
    'Pennsylvania': 'PA', 'Puerto Rico': 'PR', 'Rhode Island': 'RI', 'South Carolina': 'SC', 'South Dakota': 'SD',
    'Tennessee': 'TN', 'Texas': 'TX', 'Utah': 'UT', 'Vermont': 'VT', 'Virgin Islands': 'VI', 'Virginia': 'VA',
    'Washington': 'WA', 'West Virginia': 'WV', 'Wisconsin': 'WI', 'Wyoming': 'WY' },
    GET_RQT = {
        method: 'GET',
        headers: {
            'X-CSRF-TOKEN': undefined // don't send this header, not allowed for CORS to forestadaptation.org
        }
    };
    $scope.dismiss = $uibModalInstance.dismiss;
    // default query is ownership & state name
    var defaultQueryInput = {
        // forestadaptation only has a single "Private" as opposed to the workbook's Private [non-]industrial
        ownerships: /^Private/.test(theProject.ownership_name||'') ? 'Private' : theProject.ownership_name,
        states: STATES_HASH[theProject.state_name]
    };
    $scope.isDefaultCriteria = function() {
        return angular.equals(defaultQueryInput,$scope.queryInput);
    };
    $scope.allProjects = function(){
        $scope.queryInput.ownerships = undefined;
        $scope.queryInput.states = undefined;
    };
    /* make the demo projects list focused on the vulnerability assessment region details vs the project specific details.
    var queryInput = theProject.$vuln_region.fa_project_region ?
        {projects: theProject.$vuln_region.fa_project_region} : // the project VAR is mapped to a region in forestadaptation.org
        theProject.$vuln_region.state && theProject.$vuln_region.state.length ?
            {states: theProject.$vuln_region.state.map(function(s) { return STATES_HASH[s]; }).filter(function(s) { return !!s; }).join(',')} :
        {}; // this will only happen if the project is outside of the US in which case just let them see all demo projects.
    */
    // go get the valid criteria to let the user make selections
    $http(angular.extend({url: FaDemoProjectsUrl+'criteria'},GET_RQT))
    .then(function(response) {
        var criteria = response.data;
        // if the default criteria is in some way invalid then the user will be presented with
        // empty results from the query, put their invalid criteria into the list so it's shown
        // as selected so they can "change" the criteria
        Object.keys(defaultQueryInput).forEach(function(key) {
            if(defaultQueryInput[key] && criteria[key].indexOf(defaultQueryInput[key]) === -1) {
                criteria[key].push(defaultQueryInput[key]);
            }
        });
        $scope.validCriteria = criteria;
    });
    $scope.$watch('queryInput',function(queryInput){
        if(!queryInput) {
            $scope.queryInput = angular.copy(defaultQueryInput); // assignment will re-fire watch
        } else {
            $scope.demoProjectsUrl = FaDemoProjectsUrl+'projects?'+$httpParamSerializer(angular.extend({$top: 5, $skip: 0},queryInput));
        }
    },true/* if any criteria changes*/);
    $scope.$watch('demoProjectsUrl',function(url) {
        if(url) {
            $http(angular.extend({url:url},GET_RQT))
            .then(function(response) {
                if(response.status === 200) {
                    $scope.response = response.data;
                }
            });
        }
    });
}])
.controller('ExportCtrl',['$scope','$routeParams','$window','$timeout','$filter','$q','$http','$uibModal','CacheService','ProjectService','NiacsStrategyService','NiacsResource','TaxonomyService','ShowHideService','UserProfileService',
    function($scope,$routeParams,$window,$timeout,$filter,$q,$http,$uibModal,CacheService,ProjectService,NiacsStrategyService,NiacsResource,TaxonomyService,ShowHideService,UserProfileService){
        // only 26 possible units 1a,1b, etc.
        var a_z = [];
        var letter = 'a'.charCodeAt(0);
        var z = 'z'.charCodeAt(0);
        do {
            a_z.push(String.fromCharCode(letter));
        } while(++letter <= z);
        $scope.a_z = a_z;

        $scope.today = new Date();
        UserProfileService.get(function(profile) {
            $scope.userProfile = profile;
        });
        $scope.mapStatus = {
            ready: false,
        };
        // print/pdf are actually printing what's shown in the browser (the visible DOM).
        // print is applying the print css styles to it and pdf is traversing the DOM.
        // this means if the user has collapsed anything it won't print or end up in the PDF so we need to
        // programmatically "expand all" and restore the previous state when complete.
        $scope.print = function() {
            function doPrint() {
                // plan no longer contains expand/collapse areas
                // $timeout remains to allow dialog to be removed before print.
                //ShowHideService.expandAll();
                $timeout(function(){
                    $window.print();
                    //ShowHideService.restore();
                },500);
            }
            $uibModal.open({
                templateUrl: 'partials/dialogs/print.html',
                controller: ['$scope','$uibModalInstance',function($scope,$uibModalInstance) {
                    $scope.$uibModalInstance = $uibModalInstance;
                }],
                windowClass: 'niacs-print-plan',
                size: 'md',
            }).result.then(doPrint,doPrint); // print dialog on either ok or cancel (escape to dismiss).
        };
        $scope.pdf = function(save) {
            ShowHideService.expandAll();
            $timeout(function(){
                var pdf = niacs.pdf.generate($('#theDocument'));
                if(save) {
                    if(niacs.INFO) { // for info logging to be on the debug panel would need to have been opened.
                        pdf.output('dataurl');
                    } else {
                        pdf.save($scope.project.label+".pdf");
                    }
                }
            },500);
        };
        $scope.saveAsHtml = function() {
            ShowHideService.expandAll();
            $timeout(function(){
                $q.all([
                    $http.get(niacs.ModuleUrl+'/lib/bootstrap/dist/css/bootstrap.min.css'),
                    $http.get(niacs.ModuleUrl+'/css/export.css')
                ]).then(function(cssResponses) {
                    var link = document.querySelector('#htmlSaver'),
                    theDoc = $('#theDocument'),
                    html = '';

                    html += '<html><head>';
                    html += '<meta charset="UTF-8">';
                    html += '<meta http-equiv="Content-Language" content="en">';
                    html += '<title>'+$scope.project.label+'</title>';
                    cssResponses.forEach(function(response) {
                        html += '<style>';
                        html += response.data;
                        html += '</style>';
                    });
                    html += '</head><body class="workbook" style="padding: 0px 30px;"><div id="htmlExport"><div id="theDocument">';
                    html += theDoc.html();
                    html += '</div></div></body></html>';
    
                    link.download = $scope.project.label.replace(/\s+/g,'_')+'.html';
                    link.href = encodeURI('data:text/html;base64,'+Base64.encode(html));
                    link.click();

                    ShowHideService.restore();
                });
                
            });
        };
        $scope.isEmptyObject = niacs.isEmptyObject;
        TaxonomyService.get('niacs_vulnerability',function(data){
          $scope.vocab_vulnerability = data;
        });
        NiacsStrategyService.getSourceTree().then(function(tree) {
            $scope.strategyName = function(sid) {
                var strat = tree.getStrategy(sid);
                return strat ? tree.getStrategyLabel(strat,$scope.project) : '';
            };
            $scope.approachName = function(sid,aid) {
                var app = tree.getApproach(sid,aid);
                return app ? app.name : "";
            };
        });
        // if configured for it then discover demo projects from forestadaptation.org
        $scope.findDemoProjects = FaDemoProjectsUrl  && FaDemoProjectsUrl.indexOf('//') !== -1 ? function() {
            $uibModal.open({
                templateUrl: 'partials/dialogs/demo-projects.html',
                controller: 'DemoProjectsDialogCtrl',
                windowClass: 'niacs-demo-projects',
                size: 'lg',
                resolve: {
                    theProject: function() { return $scope.project; }
                }
            });
        } : undefined;
        // WORKAROUND?  Server owned climate impact statements have; id:number,label:string,statement:string
        // users add comments and those are held in the comments property.  The "statement" property is not used
        // in export and is only visible in the evidence dialog.  Unfortunately custom climate impact statements
        // do not currently follow this convention properly and have a text area with placeholder text "comments"
        // which is bound into the "statement" property...
        // to "fix" that would require broader changes to the application including a new project version and migrator
        // for the moment dealign with this here...
        $scope.climateImpactStatementComments = function(statement) {
            return typeof(statement.id) === 'number' ?
                statement.comments
                : (statement.comments||statement.statement); // possible future proof
        };
        function collectResources() {
            if(!$scope.project || !$scope.project.$vuln_region || !$scope.project.$vuln_region.id) {
                return;
            }
            var resources = [],seen = [];
            function addResource(r) {
                if(seen.indexOf(r.id) === -1) {
                    resources.push(r);
                    seen.push(r.id);
                }
            }
            function addProjectSpecificResources() {
                var statements = [];
                if($scope.project.cistatements && $scope.project.cistatements.length &&
                    $scope.project.$vuln_region && $scope.project.$vuln_region.$cistatements) {
                    statements = $filter('inflate')($scope.project.cistatements,$scope.project.$vuln_region.$cistatements);
                } else {
                    console.log('cistatements if fails for project',$scope.project);
                }
                angular.forEach($scope.project.units,function(unit) {
                    if(unit.cistatements && unit.$cistatements) {
                        statements = statements.concat($filter('inflate')(unit.cistatements,unit.$cistatements));
                    } else {
                        console.log('cistatements if fails for unit',unit);
                    }
                });
                angular.forEach(statements,function(statement){
                    angular.forEach(statement.$resources,addResource);
                });
                $scope.resources = resources;
                $scope.resourceCitations = resources.reduce(function(map,r,i) {
                        map[r.id] = i+1;
                        return map;
                    },{});
            }
            var regional = CacheService.get('regional-resource-list');
            if(regional) {
                angular.forEach(regional,addResource);
                addProjectSpecificResources();
            } else {
                var params = niacs.getResourceFilter($scope.project);
                params.sort = '-sticky';
                NiacsResource.query(params,function(data){
                    if(data && data.list) {
                        CacheService.put('regional-resource-list',data.list);
                        angular.forEach(data.list,addResource);
                    }
                    addProjectSpecificResources();
                });
            }
        }
        ProjectService.get($routeParams,'ExportCtrl',function(project){
            $scope.project = project;
            NiacsStrategyService.projectIsOnlyAgriculture().then(function(isAgriculture) {
                $scope.isAgriculture = isAgriculture;
            });
            $scope.units = [];
            $scope.projectAndUnits = [project];
            if(project.units && project.units.length > 0) {
                $scope.units = $scope.units.concat(project.units);
                $scope.projectAndUnits = $scope.projectAndUnits.concat(project.units);
            }
            // sections 4N and 5 turn things on their heads since both tactics and monitoring
            // variables are stored on the project but referenced as "applicable" on objectives.
            function collectProjectRefed(key) {
                return $scope.units.reduce(function(unitMap,unit) {
                    var objectiveWrappers = niacs.collectObjectives(unit)
                        .map(function(objective){

                            // pair objective with list of objects it references
                            var o = {
                                unit: unit,
                                objective: objective,
                            };
                            // which monitor||tactics are associated with the objective
                            var oids = (objective[key]||[]).map(function(t) { return t.id; });
                            o[key] = (project[key]||[]).filter(function(t) {
                                return oids.indexOf(t.id) !== -1;
                            });
                            return o;
                        });
                    // collect the set of referenced objects along with a map of object ids to objectives for each referenced object
                    var carry = {toObjectives:{}};
                    carry[key] = [];
                    unitMap[unit.id] = objectiveWrappers.reduce(function(obj,o) {
                            var set = obj[key];
                            var map = obj.toObjectives;
                            if(key === 'tactics') {
                                // tactics may not be recommended, keep track of that for display purposes
                                o.objective['$'+key+'Recommendations'] = (o.objective[key]||[]).reduce(function(map,d) {
                                        map[d.id] = d.recommended;
                                        return map;
                                    },{});
                            }
                            (o[key]||[]).forEach(function(d) {
                                map[d.id] = map[d.id]||[];
                                map[d.id].push(o.objective);
                                if(set.indexOf(d) === -1) {
                                    set.push(d);
                                }
                                if(key === 'tactics') {
                                    // for tactics only need to group by strategy (in case picked twice)
                                    var groupedApproaches = (d.approaches||[]).reduce(function(map,a) {
                                            map[a.strategy] = map[a.strategy]||[];
                                            map[a.strategy].push(a.approach);
                                            return map;
                                        },{});
                                    d.$groupedApproaches = Object.keys(groupedApproaches).map(function(key) { return {
                                                strategy: key,
                                                approaches: groupedApproaches[key]
                                            };
                                        });
                                }
                            });
                            return obj;
                        },carry);
                    
                    return unitMap;
                },{});
            }
            $scope.tacticsData = collectProjectRefed('tactics');
            $scope.monitorData = collectProjectRefed('monitor');
        });
        $scope.$watch('project.$vuln_region',collectResources);
        // When the project is loaded the vuln_region, units and ci statements
        // that are owned by the server are loaded asynchronously in the background
        // and there currently is no single promise that indicates when this is complete
        // each such load bumps the $updateCount however so whenever that happens, recalculate
        // the resources.  This isn't typically a problem if someone walks through the workbook
        // because everything has been loaded up but on an "export" view resources can
        // end up missing due to the asynchronous load, this isn't an ideal solution...
        $scope.$watch('project.$updateCount',collectResources);
}]);
